import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a792145"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cart-categories" }
const _hoisted_2 = {
  key: 0,
  class: "cart-categories-row"
}
const _hoisted_3 = { class: "category" }
const _hoisted_4 = {
  key: 0,
  class: "category-date"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.category!='null')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.__($props.category)), 1 /* TEXT */),
          ($props.start_date)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.__("Since")) + " " + _toDisplayString($setup.start_date_display), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}